import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Import Custom Data`}</h2>
    <ol>
      <li parentName="ol">{`Import the Changes from `}<a parentName="li" {...{
          "href": "/ibm-aiops-training/assets/import_change.xlsx"
        }}>{`import_change.xlsx`}</a>
        <ol parentName="li">
          <li parentName="ol">{`Select `}<inlineCode parentName="li">{`Change - All`}</inlineCode>{` from the right-hand menu`}</li>
          <li parentName="ol">{`Right Click on `}<inlineCode parentName="li">{`Number`}</inlineCode>{`in the header column`}</li>
          <li parentName="ol">{`Select Import
`}<img parentName="li" {...{
              "src": "./../images/snow/snow3.png",
              "alt": "snow"
            }}></img></li>
          <li parentName="ol">{`Chose the `}<inlineCode parentName="li">{`import_change.xlsx`}</inlineCode>{` file and click `}<inlineCode parentName="li">{`Upload`}</inlineCode>
            <img parentName="li" {...{
              "src": "./../images/snow/snow4.png",
              "alt": null
            }}></img></li>
          <li parentName="ol">{`Click on `}<inlineCode parentName="li">{`Preview Imported Data`}</inlineCode>
            <img parentName="li" {...{
              "src": "./../images/snow/snow5.png",
              "alt": null
            }}></img></li>
          <li parentName="ol">{`Click on `}<inlineCode parentName="li">{`Complete Import`}</inlineCode>{` (if there are errors or warnings just ignore them and import anyway)
`}<img parentName="li" {...{
              "src": "./../images/snow/snow6.png",
              "alt": null
            }}></img></li>
        </ol>
      </li>
      <li parentName="ol">{`Import the Incidents from `}<a parentName="li" {...{
          "href": "/ibm-aiops-training/assets/import_incidents.xlsx"
        }}>{`import_change.xlsx`}</a>
        <ol parentName="li">
          <li parentName="ol">{`Select `}<inlineCode parentName="li">{`Incidents - All`}</inlineCode>{` from the right-hand menu`}</li>
          <li parentName="ol">{`Proceed as for the Changes but for Incidents`}</li>
        </ol>
      </li>
    </ol>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`You have successfully finished this Chapter.`}</p>
      <p><strong parentName="p">{`You are now done with the chapter on  Configuring Service Now`}</strong></p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      